/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../graphql.generated'

const defaultOptions = {} as const
export type GetPatientProgressTrackerQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetPatientProgressTrackerQuery = {
  __typename?: 'Query'
  patient: {
    __typename?: 'Patient'
    uid: string
    progressTracker?: {
      __typename?: 'ProgressTracker'
      modules: Array<{
        __typename?: 'ProgressTrackerModule'
        completionRate: number
        selfCareTimeMinutes?: number | null
        goal: { __typename?: 'ModuleGoal'; practiceGoal: Types.PracticeGoal }
        days: Array<{ __typename?: 'PracticeDay'; isToday: boolean }>
      }>
    } | null
  }
}

export const GetPatientProgressTrackerDocument = gql`
  query getPatientProgressTracker($uid: ID!) {
    patient(uid: $uid) {
      uid
      progressTracker {
        modules {
          completionRate
          selfCareTimeMinutes
          goal {
            practiceGoal
          }
          days {
            isToday
          }
        }
      }
    }
  }
`

/**
 * __useGetPatientProgressTrackerQuery__
 *
 * To run a query within a React component, call `useGetPatientProgressTrackerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientProgressTrackerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientProgressTrackerQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetPatientProgressTrackerQuery(
  baseOptions: Apollo.QueryHookOptions<GetPatientProgressTrackerQuery, GetPatientProgressTrackerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPatientProgressTrackerQuery, GetPatientProgressTrackerQueryVariables>(
    GetPatientProgressTrackerDocument,
    options
  )
}
export function useGetPatientProgressTrackerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPatientProgressTrackerQuery, GetPatientProgressTrackerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPatientProgressTrackerQuery, GetPatientProgressTrackerQueryVariables>(
    GetPatientProgressTrackerDocument,
    options
  )
}
export type GetPatientProgressTrackerQueryHookResult = ReturnType<typeof useGetPatientProgressTrackerQuery>
export type GetPatientProgressTrackerLazyQueryHookResult = ReturnType<typeof useGetPatientProgressTrackerLazyQuery>
export type GetPatientProgressTrackerQueryResult = Apollo.QueryResult<
  GetPatientProgressTrackerQuery,
  GetPatientProgressTrackerQueryVariables
>
